<template>
  <div>
    <v-row>
      <v-col cols="12" md="6">
        <div>
          <h1>Add new parama bundle</h1>
        </div>
      </v-col>
      <v-col cols="12" md="6">
        <!-- <div class="d-flex justify-end">
          <div>
            <v-btn icon id="no-background-hover" to="/blog" class="">
              <span class="group pa-2">
                <v-icon medium>mdi-keyboard-backspace</v-icon>
              </span>
            </v-btn>
            
          </div>
        </div> -->
      </v-col>
    </v-row>
    <div class="my-9">
      <v-tabs v-model="tab" slider-color="transparent">
        <div
          class="d-flex"
          style="width: 100%; background: rgba(236, 241, 242, 1)"
        >
          <v-tab
            ripple
            href="#tab-1"
            @click="
              () => {
                this.tab == 'tab-1';
                this.continuebtn = true;
              }
            "
            ><span class="tabs_style text_style"> Content </span></v-tab
          >
          <v-icon class="mr-5">mdi-chevron-right</v-icon>
          <v-tab
            ripple
            href="#tab-2"
            @click="
              () => {
                this.tab == 'tab-2';
                this.continuebtn = true;
              }
            "
          >
            <span class="tabs_style text_style"> Settings </span>
          </v-tab>
          <v-icon class="mr-5">mdi-chevron-right</v-icon>

          <v-tab
            ripple
            href="#tab-3"
            @click="
              () => {
                this.tab == 'tab-3';
                this.continuebtn = false;
              }
            "
          >
            <span class="tabs_style text_style"> Royalties </span>
          </v-tab>
          <!-- <v-icon class="mr-5">mdi-chevron-right</v-icon>
          
          
          <v-tab
            ripple
            href="#tab-4"
            @click="
              () => {
                this.tab == 'tab-4';
                this.continuebtn = false;
              }
            "
          >
            <span class="tabs_style text_style"> Publish </span>
          </v-tab> -->
        </div>
        <v-tab-item value="tab-1">
          <v-card-text>
            <div style="margin: 0 8.9vw">
              <v-text-field
                single-line
                flat
                style="font-size: 2rem; max-height: initial !important"
                v-model="form.Title"
                label="Write you title here"
                height="60"
                hide-details=""
              ></v-text-field>
              <v-textarea
                single-line
                counter
                maxlength="250"
                flat
                class="mb-9 mt-4"
                v-model="form.subHeading"
                label="Write sub-heading description here "
              ></v-textarea>

              <div>
                <blogimageuploader-component @SetBanner="SetBanner" />
              </div>
              <v-select
                class="my-9"
                outlined
                v-model="filterCategory"
                :items="filterCategoryArray"
                dense
                hide-details
                label="Category"
                multiple
                persistent-hint
                :menu-props="{ maxHeight: '400' }"
              ></v-select>
              <div class="mb-2">
                <span style="font-size: 18px">
                  <b>Course Description</b>
                </span>
              </div>
              <div class="mb-5">
                <blogtextediter-component @SetContent="SetContent" />
              </div>
              <v-card outlined>
                <v-row class="pa-4">
                  <v-col cols="12" md="7">
                    <v-text-field
                      single-line
                      label="Instructor name"
                    ></v-text-field>
                  </v-col>
                  <v-col cols="12" md="5">
                    <div class="ml-2 my-2">
                      <span> <b> Instructor headshot (optional)</b> </span>
                    </div>
                    <div class="ml-2 my-2">
                      <span>(300 x 400px) </span>
                    </div>
                    <div>
                      <div style="overflow: hidden" @click="UploadImg2">
                        <v-card
                          max-width="300"
                          flat
                          color="transparent"
                          v-model="svgBackground2"
                          class="svgBackgroundSection"
                          style="overflow: hidden"
                          v-if="Src2 == null"
                        >
                          <div style="height: 100%; position: relative">
                            <CameraBorderBoxSvg></CameraBorderBoxSvg>
                          </div>
                        </v-card>
                        <v-card v-model="UploadedImage2" v-else>
                          <v-img
                            :src="Src2"
                            ref="Image2"
                            max-height="300"
                            max-width="400"
                            contain
                          ></v-img>
                        </v-card>
                      </div>

                      <input
                        type="file"
                        accept="image/png, image/gif, image/jpeg"
                        style="display: none"
                        ref="Img2"
                        @change="SetImage2"
                      />
                    </div>
                  </v-col>
                </v-row>
              </v-card>
              <div class="mt-3">
                <span> Instructor bio </span>
              </div>
              <div class="my-4">
                <blogtextediter-component @SetContent="SetContent" />
              </div>
              <div>
                <v-btn color="primary" text @click="SeeSecondInstructor = true">
                  <div class="text_style">+ Add second Instructor</div>
                </v-btn>
              </div>
              <div class="my-2">
                <v-btn
                  color="primary"
                  text
                  @click="SeePrimaryTranslator = true"
                >
                  <div class="text_style">+ Add translator</div>
                </v-btn>
              </div>
              <div>
                <v-btn color="primary" text @click="SeeSecondTranslator = true">
                  <div class="text_style">+ Add second translator</div>
                </v-btn>
              </div>
              <!---------------Second Instructor----------------------->
                <v-card outlined class="my-3" v-if="SeeSecondInstructor">
                <v-row class="pa-4">
                  <v-col cols="12">
                    <div class="d-flex justify-space-between mb-2">
                      <span> <b>Second Instructor bio </b></span>
                      <v-icon
                        color="red"
                        class="cursor-pointer"
                        @click="SeeSecondInstructor = false"
                        >mdi-close</v-icon
                      >
                    </div>
                    <div style="width: 100%">
                      <blogtextediter-component @SetContent="SetContent" />
                    </div>
                  </v-col>
                </v-row>
              </v-card>
              <!---------------Translator----------------------->
              <v-card outlined class="my-3" v-if="SeePrimaryTranslator">
                <v-row class="pa-4">
                  <v-col cols="12" md="7">
                    <v-text-field single-line label="Translator"></v-text-field>
                  </v-col>
                  <v-col
                    cols="12"
                    md="5"
                    class="d-flex justify-space-between align-start"
                  >
                    <div>
                      <div class="ml-2 my-2">
                        <span> <b> Translator headshot (optional)</b> </span>
                      </div>
                      <div class="ml-2 my-2">
                        <span>(300 x 400px) </span>
                      </div>
                      <div>
                        <div style="overflow: hidden" @click="UploadImg4">
                          <v-card
                            max-width="300"
                            flat
                            color="transparent"
                            v-model="svgBackground4"
                            class="svgBackgroundSection"
                            style="overflow: hidden"
                            v-if="Src4 == null"
                          >
                            <div style="height: 100%; position: relative">
                              <CameraBorderBoxSvg></CameraBorderBoxSvg>
                            </div>
                          </v-card>
                          <v-card v-model="UploadedImage4" v-else>
                            <v-img
                              :src="Src4"
                              ref="Image4"
                              max-height="300"
                              max-width="400"
                              contain
                            ></v-img>
                          </v-card>
                        </div>

                        <input
                          type="file"
                          accept="image/png, image/gif, image/jpeg"
                          style="display: none"
                          ref="Img4"
                          @change="SetImage4"
                        />
                      </div>
                    </div>
                    <v-icon
                      color="red"
                      class="cursor-pointer"
                      @click="SeePrimaryTranslator = false"
                      >mdi-close</v-icon
                    >
                  </v-col>
                </v-row>
              </v-card>
              <!---------------Second Translator----------------------->
              <v-card outlined class="my-3" v-if="SeeSecondTranslator">
                <v-row class="pa-4">
                  <v-col cols="12" md="7">
                    <v-text-field
                      single-line
                      label="Second Translator"
                    ></v-text-field>
                  </v-col>
                  <v-col
                    cols="12"
                    md="5"
                    class="d-flex justify-space-between align-start"
                  >
                    <div>
                      <div class="ml-2 my-2">
                        <span> <b> Translator headshot (optional)</b> </span>
                      </div>
                      <div class="ml-2 my-2">
                        <span>(300 x 400px) </span>
                      </div>
                      <div>
                        <div style="overflow: hidden" @click="UploadImg5">
                          <v-card
                            max-width="300"
                            flat
                            color="transparent"
                            v-model="svgBackground5"
                            class="svgBackgroundSection"
                            style="overflow: hidden"
                            v-if="Src5 == null"
                          >
                            <div style="height: 100%; position: relative">
                              <CameraBorderBoxSvg></CameraBorderBoxSvg>
                            </div>
                          </v-card>
                          <v-card v-model="UploadedImage5" v-else>
                            <v-img
                              :src="Src5"
                              ref="Image5"
                              max-height="300"
                              max-width="400"
                              contain
                            ></v-img>
                          </v-card>
                        </div>

                        <input
                          type="file"
                          accept="image/png, image/gif, image/jpeg"
                          style="display: none"
                          ref="Img5"
                          @change="SetImage5"
                        />
                      </div>
                    </div>
                    <v-icon
                      color="red"
                      class="cursor-pointer"
                      @click="SeeSecondTranslator = false"
                      >mdi-close</v-icon
                    >
                  </v-col>
                </v-row>
              </v-card>
              <div>
                <v-menu
                  ref="menu"
                  v-model="menu"
                  :close-on-content-click="false"
                  :return-value.sync="date"
                  transition="scale-transition"
                  offset-y
                  min-width="auto"
                >
                  <template v-slot:activator="{ on, attrs }">
                    <v-text-field
                      v-model="date"
                      label="Course Start Date (Optional)"
                      prepend-icon="mdi-calendar"
                      readonly
                      class="mt-6"
                      v-bind="attrs"
                      v-on="on"
                    ></v-text-field>
                  </template>
                  <v-date-picker v-model="date" no-title scrollable>
                    <v-spacer></v-spacer>
                    <v-btn text color="primary" @click="menu = false">
                      Cancel
                    </v-btn>
                    <v-btn text color="primary" @click="$refs.menu.save(date)">
                      OK
                    </v-btn>
                  </v-date-picker>
                </v-menu>
              </div>
            </div>
          </v-card-text>
        </v-tab-item>
        <v-tab-item value="tab-2">
          <v-card-text>
            <div style="margin: 0 8.9vw">
              <v-card
                class="my-6 pa-9"
                flat
                color="#FBFBFF"
                style="border: 1px solid #dee3ef"
              >
                <div>
                  <span class="h1_tab2"> Courses Included in Bundle</span>

                  <v-card class="mt-6" flat>
                    <v-text-field
                      dense
                      single-line
                      class="pt-1"
                      outlined
                      hide-details
                    ></v-text-field>
                    <!-- <v-select
                      class="pt-1"
                      multiple
                      :items="permissionsArray"
                      label="Permissions"
                      dense
                      single-line
                      outlined
                      hide-details=""
                    ></v-select> -->
                  </v-card>
                </div>

                <div class="my-8">
                  <span class="h1_tab2">Display Order </span>

                  <v-card class="mt-6" flat>
                    <v-select
                      class="pt-1"
                      :items="VisibilityArray"
                      label="Visible (default)"
                      dense
                      single-line
                      outlined
                      hide-details=""
                    ></v-select>
                  </v-card>
                </div>
              </v-card>
              <v-card
                class="my-6 pa-9"
                flat
                color="#FBFBFF"
                style="border: 1px solid #dee3ef"
              >
                <div class="my-8">
                  <span class="h1_tab2">Language </span>
                  <!-- <span style="display: block"
                    >Lorem ipsum dolor sit amet consectetur adropising
                  </span> -->
                  <v-card class="mt-6" flat>
                    <v-select
                      class="pt-1"
                      v-model="selectedLanguage"
                      :items="LanguageArray"
                      label="Visible (default)"
                      dense
                      single-line
                      outlined
                      hide-details=""
                    ></v-select>
                  </v-card>
                </div>
                <div class="mt-8">
                  <span class="h1_tab2">Price </span>

                  <v-card class="mt-6" flat>
                    <v-text-field
                      label="Price"
                      single-line
                      outlined
                      hide-details
                      dense
                    ></v-text-field>
                  </v-card>
                </div>
                <div class="mt-8">
                  <span class="h1_tab2">Currency </span>

                  <v-card class="mt-6" flat>
                    <v-text-field
                      label="USD"
                      single-line
                      outlined
                      hide-details
                      dense
                    ></v-text-field>
                  </v-card>
                </div>
                <div class="mt-4">
                  <v-row>
                    <v-col cols="12" md="4" class="pb-0">
                      <span class="h1_tab2">Member Discount </span>

                      <v-card class="mt-4" flat>
                        <v-select
                          class="pt-1"
                          :items="MemberArray"
                          label="Member Level"
                          dense
                          single-line
                          outlined
                          hide-details=""
                        ></v-select>
                      </v-card>
                    </v-col>
                    <v-col cols="12" md="4" class="pb-0">
                      <span class="h1_tab2"> </span>

                      <v-card class="mt-12" flat>
                        <v-text-field
                          class=" "
                          label="USD Percentage off"
                          dense
                          single-line
                          outlined
                          hide-details=""
                        ></v-text-field>
                      </v-card>
                    </v-col>
                  </v-row>
                </div>
                <div class="my-3">
                  <v-row
                    v-for="(div, index) in divs"
                    :key="div.id"
                    :div="(div = index)"
                  >
                    <v-col cols="12" md="4">
                      <v-card class="mt-6" flat>
                        <v-select
                          class="pt-1"
                          :items="MemberArray"
                          label="Member Level"
                          dense
                          single-line
                          outlined
                          hide-details=""
                        ></v-select>
                      </v-card>
                    </v-col>
                    <v-col cols="12" md="4">
                      <v-card class="mt-7 d-flex align-center" flat>
                        <v-text-field
                          class=" "
                          label="USD Percentage off"
                          dense
                          single-line
                          outlined
                          hide-details=""
                        ></v-text-field>
                        <v-icon
                          style="cursor: pointer"
                          @click="RemoveRowMembershipDiscount(div.id)"
                          color="red"
                          class="ml-7"
                          >mdi-delete</v-icon
                        >
                      </v-card>
                    </v-col>
                  </v-row>
                </div>
                <v-btn
                  color="primary"
                  text
                  style="text-transform: none"
                  @click="addRow"
                >
                  + Add Member Level
                </v-btn>
              </v-card>
              <v-card
                class="my-2 pa-9"
                flat
                color="#FBFBFF"
                style="border: 1px solid #dee3ef"
              >
                <span class="h1_tab2">Add Video URL </span>

                <v-card class="mt-6" flat>
                  <v-text-field
                    label="(Youtube Link)"
                    single-line
                    outlined
                    hide-details
                    dense
                  ></v-text-field>
                </v-card>
                <div class="mt-3">
                  <span class="h1_tab2">Waiver </span>
                </div>

                <!-----------------for multiple file uploader---------------------------------------------->
                <v-card outlined height="100" class="px-6 mt-4">
                  <div class="d-flex align-center" style="height: 100%">
                    <v-chip
                      color="primary"
                      @click:close="closechip(i)"
                      close
                      outlined
                      pill
                      :key="i"
                      v-for="(c, i) in UploadedfileName"
                      >{{ c.name }}</v-chip
                    >
                  </div>
                </v-card>
                <div>
                  <v-btn
                    class="text_style my-4 px-11"
                    color="primary"
                    outlined
                    @click="onButtonClick"
                    >Upload document</v-btn
                  >
                  <input
                    ref="uploader"
                    class="d-none"
                    multiple
                    type="file"
                    accept="application/msword, application/vnd.ms-excel, application/vnd.ms-powerpoint,
                      text/plain, application/pdf,"
                    @change="onFileChanged"
                  />
                </div>
                <!-----------------optional Waiver--------------------------------------->
                <div class="mt-4">
                  <span class="h1_tab2"
                    >Waiver 2
                    <span
                      style="font-size: 20px; color: #636364; font-weight: 400"
                    >
                      (optional)</span
                    >
                  </span>

                  <v-card outlined height="100" class="px-6 mt-4">
                    <div class="d-flex align-center" style="height: 100%">
                      <v-chip
                        color="primary"
                        @click:close="closechip(i)"
                        close
                        outlined
                        pill
                        :key="i"
                        v-for="(c, i) in UploadedfileName"
                        >{{ c.name }}</v-chip
                      >
                    </div>
                  </v-card>
                  <div>
                    <v-btn
                      class="text_style my-4 px-11"
                      color="primary"
                      outlined
                      @click="onButtonClick"
                      >Upload document</v-btn
                    >
                    <input
                      ref="uploader"
                      class="d-none"
                      multiple
                      type="file"
                      accept="application/msword, application/vnd.ms-excel, application/vnd.ms-powerpoint,
                      text/plain, application/pdf,"
                      @change="onFileChanged"
                    />
                  </div>
                </div>
              </v-card>
              <v-card
                class="my-2 pa-9"
                flat
                color="#FBFBFF"
                style="border: 1px solid #dee3ef"
              >
                <span class="h1_tab2">Related courses 3/4 </span>
                <!-- <span style="display: block"
                  >Connect related content from your News to give readers more
                  to explore.
                </span> -->
                <v-row class="pa-2">
                  <v-col
                    cols="12"
                    md="4"
                    v-for="(item, index) in relatedContentArray"
                    :key="index"
                  >
                    <div>
                      <v-card
                        class="mb-12"
                        outlined
                        style="border: 1px solid rgba(8, 8, 22, 0.15)"
                        flat
                      >
                        <v-img height="250" :src="item.img"></v-img>

                        <v-card
                          class=""
                          rounded="circle"
                          color="white"
                          flat
                          style="position: absolute; top: 5px; right: 0"
                        >
                          <v-icon
                            close
                            color="primary"
                            @click="close = close(index)"
                            >mdi-close</v-icon
                          >
                        </v-card>
                        <div class="pa-4">
                          <span class="content_span"
                            >Lorem ipsum dolor sit amet consectetur
                            adropising</span
                          >
                          <div>
                            <span class="content_date">September 23, 2021</span>
                          </div>
                          <div class="mt-3">
                            <v-chip color="#E2F2E6" class="px-6">
                              <span class="content_chip">
                                Published
                              </span></v-chip
                            >
                          </div>
                        </div>
                      </v-card>
                    </div>
                  </v-col>
                </v-row>

                <v-btn
                  class="px-6 text_style"
                  outlined
                  style="
                    border: 1px solid rgba(8, 8, 22, 0.15);
                    color: rgba(34, 34, 34, 0.7);
                  "
                  >Add Related course
                </v-btn>
              </v-card>
            </div>
          </v-card-text>
        </v-tab-item>
        <v-tab-item value="tab-3"> <royalitytab /> </v-tab-item>
      </v-tabs>
    </div>
    <v-divider class="my-6"></v-divider>
    <v-card flat class="d-flex justify-end mb-9">
      <v-btn
        outlined
        style="border: thin solid rgba(8, 8, 22, 0.15)"
        class="px-9 py-2 mx-9 text_style"
        >Save Draft</v-btn
      >
      <v-btn
        color="primary"
        class="px-9 py-2 text_style"
        @click="changeTab()"
        v-if="continuebtn == true"
        >Continue</v-btn
      >
      <v-btn
        color="primary"
        class="px-9 py-2 text_style"
        v-if="continuebtn == false"
      >
        <span v-if="btnloader != true"> Publish now </span>
        <v-progress-circular
          indeterminate
          size="20"
          class="px-5"
          color="white"
          v-show="btnloader"
        ></v-progress-circular>
      </v-btn>
    </v-card>
  </div>
</template>

<script>
import BlogimageuploaderComponent from "./blogimageuploader.component.vue";
import BlogtextediterComponent from "./blogtextediter.component.vue";
import CameraBorderBoxSvg from "../../../assets/SvgIcons/CameraborderboxSvg.vue";
import { mapGetters } from "vuex";
import Royalitytab from "./royalitytab.vue";

export default {
  components: {
    BlogimageuploaderComponent,
    BlogtextediterComponent,
    Royalitytab,
    CameraBorderBoxSvg,
  },
  name: "NewParamaBundleComponent",
  computed: {
    ...mapGetters(["GetLoggedInUser"]),
  },
  mounted() {
    this.form.SubmittedBy = this.GetLoggedInUser.Username;
  },

  data() {
    return {
      SeeSecondInstructor: false,
      SeePrimaryTranslator: false,
      SeeSecondTranslator: false,

      svgBackground2: true,
      UploadedImage2: false,
      img2: {},
      Src2: null,

      svgBackground3: true,
      UploadedImage3: false,
      img3: {},
      Src3: null,
      svgBackground4: true,
      UploadedImage4: false,
      img4: {},
      Src4: null,
      svgBackground5: true,
      UploadedImage5: false,
      img5: {},
      Src5: null,

      div: 0,
      divs: [],
      menu: false,
      selectedFile: null,
      chip1: false,
      isSelecting: false,
      UploadedfileName: [],
      CurrencyTypeArray: ["USD"],
      CurrencyType: "USD",
      FreeCourseCheckBox: true,
      prerequisitesDialog: false,
      items: "",
      btnloader: false,
      Rcontentdialog: false,
      continuebtn: true,
      tab: "tab-1",
      chipsvalue: null,
      chips: [],
      selection: 1,
      selectedLanguage: "English",
      LanguageArray: [
        "English",
        "French",
        "German",
        "Japanese",
        "Italian",
        "Portuguese",
        "Filipino",
        "Spanish",
        "Chinese",
        "Russian",
      ],
      selectedLevel: "Beginner (default)",
      LevelsArray: [
        "Beginner (default)",
        "Entry-Level Training",
        "Intermediate Training",
        "Advanced Training",
        "Very Advanced Training",
      ],
      VisibilityArray: ["Visible", "Not Visible"],
      permissionsArray: [
        "Free",
        "Access",
        "Life Science ",
        "Standard ",
        "Practitioner",
        "Instructor",
      ],
      visible: ["Hide", "Show"],
      filterCategory: [],
      filterCategoryArray: [
        "Anatomy and Physiology",
        "AnimalTalk",
        "BodyTalk Access",
        "BodyTalk Courses",
        "BreakThrough",
        "CEUs",
        "Conferences",
        "Courses LS",
        "FREE Courses",
        "FSI",
        "Group Sessions",
      ],
      form: {
        Title: "",
        Banner: "",
        Content: "",
        Language: "",
        SubmittedBy: "",
        Visibility: "",
        subHeading: "",
      },
      relatedContentArray: [
        {
          img: "https://cdn.vuetifyjs.com/images/cards/cooking.png",
          title: "Lorem ipsum dolor sit amet consectetur adropising",
          desc: "September 23, 2021",
        },
        {
          img: "https://cdn.vuetifyjs.com/images/cards/cooking.png",
          title: "Lorem ipsum dolor sit amet consectetur adropising",
          desc: "September 23, 2021",
        },
        {
          img: "https://cdn.vuetifyjs.com/images/cards/cooking.png",
          title: "Lorem ipsum dolor sit amet consectetur adropising",
          desc: "September 23, 2021",
        },
      ],
    };
  },
  methods: {
    UploadImg2() {
      this.$refs.Img2.click();
    },
    SetImage2() {
      var reader = new FileReader();
      reader.onload = () => {
        this.Src2 = reader.result;
        this.$refs.Image2.src = reader.result;
      };
      // this.$emit("SetBanner", this.$refs.Img.files[0]);
      reader.readAsDataURL(this.$refs.Img2.files[0]);
    },
    UploadImg3() {
      this.$refs.Img3.click();
    },
    SetImage3() {
      var reader = new FileReader();
      reader.onload = () => {
        this.Src3 = reader.result;
        this.$refs.Image3.src = reader.result;
      };
      // this.$emit("SetBanner", this.$refs.Img.files[0]);
      reader.readAsDataURL(this.$refs.Img3.files[0]);
    },
    UploadImg4() {
      this.$refs.Img4.click();
    },
    SetImage4() {
      var reader = new FileReader();
      reader.onload = () => {
        this.Src4 = reader.result;
        this.$refs.Image4.src = reader.result;
      };
      // this.$emit("SetBanner", this.$refs.Img.files[0]);
      reader.readAsDataURL(this.$refs.Img4.files[0]);
    },
    UploadImg5() {
      this.$refs.Img5.click();
    },
    SetImage5() {
      var reader = new FileReader();
      reader.onload = () => {
        this.Src5 = reader.result;
        this.$refs.Image5.src = reader.result;
      };
      // this.$emit("SetBanner", this.$refs.Img.files[0]);
      reader.readAsDataURL(this.$refs.Img5.files[0]);
    },
    addRow() {
      this.divs.push({
        div: this.div,
      });
    },
    RemoveRowMembershipDiscount() {
      this.divs.pop({
        div: this.div,
      });
    },
    close(index) {

      this.relatedContentArray.splice(
        this.relatedContentArray.indexOf(index),
        1
      );
      this.relatedContentArray.splice(
        this.relatedContentArray.indexOf(index),
        2
      );
    },
    closechip(index) {
      
      var list = [];
      for (var i = 0; i < this.UploadedfileName.length; i++) {
        if (i != index) {
          list.push(this.UploadedfileName[i]);
        }
      }
      this.UploadedfileName = list;
    },
    onButtonClick() {
      this.isSelecting = true;
      window.addEventListener(
        "focus",
        () => {
          this.isSelecting = false;
        },
        { once: true }
      );

      this.$refs.uploader.click();
    },
    onFileChanged(e) {
      this.chip1 = true;
      if (e.target.files.length > 0) {
        for (var i = 0; i < e.target.files.length; i++) {
          this.UploadedfileName.push(e.target.files[i]);
        }
        e.target.value = "";
      }

      // do something
    },
    RelatedContentSend() {
      setTimeout(() => {
        this.btnloader = true;
      }, 100);
      setTimeout(() => {
        this.Rcontentdialog = false;
        this.btnloader = false;
      }, 2000);
    },
    reserve() {
      this.loading = true;

      setTimeout(() => (this.loading = false), 2000);
    },
    remove(item) {
      this.chips.splice(this.chips.indexOf(item), 1);
      this.chips = [...this.chips];
    },
    changeTab() {
      
      if (this.tab == "tab-1") {
        this.tab = "tab-2";
      } else {
        this.tab = "tab-3";
        this.continuebtn = false;
      }
    },
    SetContent(content) {
      this.form.Content = content;
    },
    SetBanner(banner) {
      
      this.form.Banner = banner;
    },
  },
};
</script>

<style scoped>
h1 {
  font-family: "Noto Serif";
  font-size: 40px;
  font-weight: 700;
  line-height: 54px;
  letter-spacing: 0em;
  text-align: left;
  color: #222222;
}
.tabs_style {
  font-family: "DM Sans";
  font-size: 16px;
  font-weight: 500;
  line-height: 21px;
  letter-spacing: 0em;
}
a:hover {
  text-decoration: none;
}
.v-tabs-slider {
  background-color: white !important;
}
.h1_tab2 {
  font-family: "DM Sans";
  font-size: 20px;
  font-weight: 500;
  line-height: 26px;
}
.content_span {
  font-family: " DM Sans";
  font-size: 14px;
  font-weight: 700;
  line-height: 18px;
}
.content_date {
  font-family: "DM Sans";
  font-size: 12px;
  font-weight: 400;
  line-height: 16px;
  color: rgba(8, 8, 22, 0.38);
}
.content_chip {
  font-family: "DM Sans";
  font-size: 10px;
  font-weight: 400;
  line-height: 13px;
  color: #54be5a;
}
#no-background-hover::before {
  background-color: transparent !important;
}
@media screen and (max-width: 750px) {
  h1 {
    font-size: 23px;
  }
}
@media screen and (max-width: 430px) {
  .v-application .mx-14 {
    margin-right: 20px !important;
    margin-left: 10px !important;
  }
}
</style>
